import React, { useState } from 'react'
import { Dialog } from 'components'
import { Button } from '@mui/material'
import { useUpdateStudentAssetsMutation } from 'features/students/studentApiSlice'
import { useDispatch } from 'react-redux'
import { successSnack } from 'features/snack-bar/snackSlice'
import { assetsFormatter } from 'formatters'
import numeral from 'numeral'

/**
 *
 * @param {*} _props
 * @returns
 */
export default function SetStudentAssetsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    rowData = {},
    limit = 0,
    isBus = false,
  } = _props

  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }
  // console.log(rowData, 'rowData')
  const rawCantactivosValue = isBus
    ? rowData.amountbuscriptos?.[0]?.cantactivos
    : rowData.cantactivos
  const cantactivos = numeral(rawCantactivosValue ?? 0).value() || 0

  const decreeNumber =
    rowData.studentdecrees?.find((decree) => decree.proceedingid === null)
      ?.decreenumber || ''

  const rawAsignedValue = isBus
    ? rowData.amountbuscriptos?.[0]?.asigned
    : rowData.asigned
  const asigned = numeral(rawAsignedValue ?? 0).value() || 0

  const asignedAssets = asigned / 100 - cantactivos / 100
  const remainingAssets = limit - asignedAssets

  const [updateStudentAssets] = useUpdateStudentAssetsMutation()

  function handleSubmit(data) {
    console.log(data, 'data')
    const mutation = updateStudentAssets({
      studentList: [
        {
          studentdni: rowData.studentdni,
          cantactivos: numeral(data.cantactivos).value(),
        },
      ],
      topAmountType: isBus ? 'b' : 'e',
      cycle: parseInt(rowData.schoolcycle),
      decreeNumber: data.decreeNumber,
    })
    mutation
      .then((response) => {
        if (response?.data?.added?.length > 0) {
          dispatch(
            successSnack({
              message: `Activos actualizados para el estudiante ${
                Boolean(rowData.firstname) ? rowData.firstname + ' ' : ''
              }${Boolean(rowData.lastname) ? rowData.lastname + ' ' : ''}`,
            }),
          )
          closeDialog()
        }
      })
      .catch((error) => {})
  }

  const message = `Ingresa la cantidad de activos digitales de los ${assetsFormatter(
    remainingAssets * 100,
  )} que\n${Boolean(rowData.firstname) ? ' ' + rowData.firstname : ''}${
    Boolean(rowData.lastname) ? ' ' + rowData.lastname : ''
  }, DNI: ${rowData?.studentdni} tiene disponibles para el ciclo ${
    rowData?.schoolcycle
  }`
  const textBtn = 'Definir' + (isBus ? 'BUS' : '') + ' Activos'
  const txtTitle =
    'Definir ' + (isBus ? 'BUS' : '') + ' Activos Para ' + rowData.schoolcycle
  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText={textBtn} //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={txtTitle} // 'Dialog title'
          message={message}
          onSubmit={handleSubmit} // Form submit action
          focusOnFirstInput={false}
          fields={[
            {
              name: 'cantactivos',
              helperText: `Introduzca un valor mayor o igual a 0 y menor o igual a ${assetsFormatter(
                remainingAssets * 100,
              )} sin decimales`, // 'Dialog message'
              label: 'Cantidad',
              defaultValue:
                cantactivos > 0
                  ? assetsFormatter(cantactivos, 'noCurrency')
                  : '', // 'Dialog message'
              placeholder: '0',
              type: 'number',
              validation: {
                required: 'La cantidad de activos debe ser mayor o igual a 0',
                min: {
                  value: 0,
                  message: 'La cantidad de activos debe ser mayor o igual a 0',
                },
                max: {
                  value: remainingAssets,
                  message: `La cantidad de activos debe ser menor o igual a ${assetsFormatter(
                    remainingAssets * 100,
                  )}`,
                },
              },
            },
            {
              name: 'decreeNumber',
              helperText: decreeNumber === '' ? `Introduzca un valor` : '', // 'Dialog message'
              label: 'Decreto Número',
              defaultValue: decreeNumber, // 'Dialog message'
              placeholder: '',
              type: 'text',
              disabled: decreeNumber === '' ? false : true,
              validation: {
                required: 'El número de decreto es requerido',
                maxLength: {
                  value: 100,
                  message:
                    'El número de decreto no puede superar los 100 caracteres',
                },
              },
            },
          ]}
        />
      )}
    </>
  )
}
